export const PAYMENT_METHODS = {
  CASH_ONLY: {
    cash: true,
  },
  CARD_ONLY: {
    card: true,
  },
  CASH_AND_CARD: {
    cash: true,
    card: true,
  },
}
